import React from 'react';
import { Route, useParams } from 'react-router-dom';

import GuaranteesTableRecords from '../../RentGuarantees/_partials/GuaranteesTableRecords';
import LoansTableRecords from '../../AdminLoans/LoansTableRecords';

import './CustomerDetailsLoan.scss';

const CustomerDetailsLoan = ({ payload }: any) => {
  const { customerId } = useParams<{ customerId: string}>();
  const Tabs = [
    {
      id: 1, name: 'Credit Request', link: `/customers/customer-details/${customerId}/loan/credits`,
    },
    {
      id: 2, name: 'Guarantees Request', link: `/customers/customer-details/${customerId}/loan/guarantee`,
    },

  ];

  return (
    <div className="customer-details-loan-cover">
      <Route path={`/customers/customer-details/${customerId}/loan/credits`}>
        <LoansTableRecords payload={payload} defaultUrl={`/customers/customer-details/${customerId}/loan/credits`} toggleStorageId="customer-details-loan-table-col" userId={customerId} subTab={Tabs} permissionName="can-view-all-credit-request-tab" />
      </Route>

      <Route path={`/customers/customer-details/${customerId}/loan/guarantee`}>
        <GuaranteesTableRecords type="all" userId={customerId} defaultUrl={`/customers/customer-details/${customerId}/loan/guarantee`} toggleStorageId="all_guarantees-table-col" payload={payload} hasNameAndImage permissionName="can-view-all-guarantees-tab" subTab={Tabs} />
      </Route>

    </div>
  );
};
export default CustomerDetailsLoan;
